define('model/BookingRescheduleModel',['require','lib/model/BaseModel'],function (require) {

	var Parent = require('lib/model/BaseModel');
	
	return Parent.extend({
		
		urlRoot: '/booking/reschedule/id/',
        
        skipNavigationOnCalendar: true,
        
        allowRedirectOnAnyProvider: false,
        
        // dummies
        updatePredefinedClientInfo: function () {},
        
        getAddons: function () {
            var ids = _.pluck(
                _.where(this.get('product_list'), {type: 'attribute'}),
                'id'
            );
            if (_.isEmpty(ids)) return undefined;
            
            return ids.join(',');
        },
        
        getProductsAddonsList: function () {
            return this.get('product_list');
        },
        
        toJSON: function (options) {
			var result = Backbone.Model.prototype.toJSON.apply(this, [options]);

            var service = this.get('service');
            // var duration = service ? service.duration * 60 * 1000 : 0;
            // var buffertimeAfter = service ? service.buffertime_after * 60 * 1000 : 0;
            // var buffertimeBefore = service ? service.buffertime_before * 60 * 1000 : 0;
            
            if (this.get('date_start')) {
    			var startDateTime = result.start_datetime_raw = Date.parseMysqlDate(this.get('date_start'));
                // result.start_datetime = new Date(startDateTime.getTime() + buffertimeBefore);
                result.start_datetime = new Date(startDateTime.getTime());
            }

			if (this.get('date_end')) {
				var endDateTime = result.end_datetime_raw = Date.parseMysqlDate(this.get('date_end'));
                // result.end_datetime = new Date(endDateTime.getTime() - buffertimeBefore - buffertimeAfter);
                result.end_datetime = new Date(endDateTime.getTime());
			}

			return result;
		},

    });
    
});
